import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { inventoryPageBreadcrumbs } from './config';
import { NavigateLinks } from '@/components';
import { icons } from '@/assets';

import style from './Inventory.module.css';

export const Inventory = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(() => inventoryPageBreadcrumbs(navigate), []);

  return (
    <section className={style.header}>
      <NavigateLinks actualPage='Inventario' breadcrumbs={breadcrumbs} />
      <section className={style.container}>
      <ul className={style.modules}>
        <li
          className={style.module}
          onClick={() => navigate('/inventory/geography')}
        >
          <img src={icons.geography} alt='Icono de ubicaciones' />
          <p>Ubicaciones</p>
        </li>
        <li
          className={style.module}
          onClick={() => navigate('/inventory/users')}
        >
          <img src={icons.users} alt='Icono de usuario' />
          <p>Usuarios</p>
        </li>
        <li
          className={style.module}
          onClick={() => navigate('/inventory/assets')}
        >
          <img src={icons.assets} alt='Icono de activos' />
          <p>Activos</p>
        </li>
        <li
          className={style.module}
          onClick={() => navigate('/inventory/assignments')}
        >
          <img src={icons.assignment} alt='Icono de ubicaciones' />
          <p>Asignaciones</p>
        </li>
        <li
          className={style.module}
          onClick={() => navigate('/inventory/service-history')}
        >
          <img
            src={icons.serviceHistory}
            alt='Icono de historial de servicios'
          />
          <p>Historial de servicios</p>
        </li>
        <li
          className={style.module}
          onClick={() => navigate('/inventory/requests')}
        >
          <img src={icons.request} alt='Icono de peticiones' />
          <p>Peticiones</p>
        </li>
      </ul>
    </section>
    </section>
  );
};
